import { STICKY_ALERT_TYPE, StickyAlertType } from '@/modules/alerts/models/sticky-alert-type';
import { Component } from 'vue';
import WCTestStickyAlert from '@/modules/alerts/components/WCTestStickyAlert/WCTestStickyAlert.vue';
import WCBasicStickyAlert from '@/modules/alerts/components/WCBasicStickyAlert/WCBasicStickyAlert.vue';
import WCNotificationStickyAlert from '@/modules/alerts/components/WCNotificationStickyAlert/WCNotificationStickyAlert.vue';
import WCMessageStickyAlert from '@/modules/alerts/components/WCMessageStickyAlert/WCMessageStickyAlert.vue';
import WCBannerStickyAlert from '@/modules/alerts/components/WCBannerStickyAlert/WCBannerStickyAlert.vue';

const STICKY_ALERT_COMPONENT_REGISTRY: Record<StickyAlertType, Component> = {
  [STICKY_ALERT_TYPE.TEST]: WCTestStickyAlert,
  [STICKY_ALERT_TYPE.BASIC]: WCBasicStickyAlert,
  [STICKY_ALERT_TYPE.NOTIFICATION]: WCNotificationStickyAlert,
  [STICKY_ALERT_TYPE.MESSAGE]: WCMessageStickyAlert,
  [STICKY_ALERT_TYPE.BANNER]: WCBannerStickyAlert,
};

export default STICKY_ALERT_COMPONENT_REGISTRY;
